import { Link } from "react-router-dom";

/**
 * Dietico brand mark.
 *  - `variant="icon"`  → just the apple mark
 *  - `variant="lockup"` → apple mark + "Dietico" wordmark (Geist)
 */
export function Logo({ variant = "lockup", className = "" }) {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2.5 group ${className}`}
      aria-label="Dietico — Hospital Diet Assessor"
    >
      <img
        src="/dietico-icon.png"
        alt="Dietico logo"
        width="32"
        height="32"
        loading="eager"
        decoding="async"
        className="h-8 w-8 object-contain transition-transform group-hover:scale-105"
      />
      {variant === "lockup" && (
        <span className="text-lg font-medium tracking-tight text-foreground">
          Dietico
        </span>
      )}
    </Link>
  );
}
